import React from "react"
import styles from './heroSection.module.css';
import img from './images/main-image.jpg'
import {FadeIn, FadeInUp} from "../../shared/ui/animations";

class HeroSection extends React.Component {
    render() {
        return (
            <section className={`${styles.mainSection}`} id="main-page">
                <FadeIn>
                    <img src={img} alt="" className={styles.bgImg}/>
                </FadeIn>
                <div className="container-custom my-0">
                    <FadeInUp delay={200}>
                        <h1>Создай свой мир, <br/> раскрой свою
                            <div className={`d-flex justify-content-between ${styles.legendText}`}>
                                <div className="col-md-3"></div>
                                <FadeInUp delay={400}>
                                    <p className={`${styles.subText} body-bold col-md`}>
                                        Здесь не нужно ничего, кроме твоей фантазии. Мы создаем миры, где ты становишься главным героем: магом, нетраннером или охотником за сокровищами.
                                    </p>
                                </FadeInUp>
                                Легенду!
                            </div>
                        </h1>
                    </FadeInUp>
                </div>

            <FadeIn delay={600}>
                <a href={'/#form-section'} className={`btn btn-red-filled ${styles.heroBtn}`}>Записаться</a>
            </FadeIn>
            </section>
        )
    }
}

export default HeroSection;